export default {
    NOTRANSITION: 'g-notransition',
    ANIM_FADE: 'g-anim-fade',
    ANIM_FADE_IN: 'g-anim-fade_in',
    HIDDEN: 'g-hidden',
    SCROLL_MEASURE: 'scroll-measure',
};
